import { useConfigStore } from '@/stores/configStore';

/** Returns the booth number when the store is an exhibition company and the search menu allows showing it, otherwise ''. */
export const useVisibleBoothNumber = (boothNumber?: string): string => {
    const isExhibitionCompany = useConfigStore((s) => s.config.server?.company?.companyType === '3');
    const showBoothNumber = useConfigStore((s) => {
        const config = s.config;
        const searchMenu =
            config.server?.buildingMenus?.[config.ui.language]?.find((menu) => menu.menuType === 'SEARCH') ??
            config.server?.buildingMenus?.[config.ui.mainLanguage]?.find((menu) => menu.menuType === 'SEARCH');
        return searchMenu?.showBoothNumber !== false;
    });

    return isExhibitionCompany && showBoothNumber ? (boothNumber ?? '') : '';
};
